import PhoneConfirmation from '@/components/organism/Registration/PhoneConfirmation/PhoneConfirmation.container';

export const PhoneConfirmationPage = () => <PhoneConfirmation />;
